export default "__VITE_ASSET__9abb8556__"